<mat-form-field class="width" [formGroup]="formGroup" [appearance]="appearance">

    <mat-label>
        {{label}}
    </mat-label>

    <input 
        matInput 
        placeholder="z.B. Stadt, Postleitzahl" 
        formControlName="filter" 
        (keyup.enter)="onSearchClicked($event)" 
        [matAutocomplete]="autoComplete" 
        autocomplete="new-password"
        (focus)="onFocus($event)" 
        (blur)="onBlur($event)" 
        #input />

    <div matSuffix class="suffix-controls-wrapper">
            
        <button mat-icon-button @fade matSuffix color="warn" *ngIf="valueControl.value" (click)="clearValue($event)">
            <mat-icon>clear</mat-icon>
        </button>

    </div>

    <mat-autocomplete class="edit-view-auto-complete" #autoComplete="matAutocomplete">

        <mat-option *ngIf="valueControl.value" [value]="null" (click)="setAddress(null)" class="option-null-value">
            Nicht festgelegt
        </mat-option>

        <mat-option *ngFor="let address of addresses" [value]="address.addressId" (click)="setAddress(address)">
            {{displayAddress(address)}}
        </mat-option>

    </mat-autocomplete>

</mat-form-field>